var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { getEmployerOrPlatformQueryParam } from '../../socket';
import { toSnakeCase } from '../../utils/case-conversion';
import { getHubEnvironment } from '../../utils';
// const LINK_API_URL = 'https://link-api.getpinwheel.com/';
export var LINK_API_URL = process.env.LINK_API_URL
    ? process.env.LINK_API_URL
    : getHubEnvironment() === 'production'
        ? 'https://api.getpinwheel.com'
        : 'https://staging-api.getpinwheel.com';
export var getLinkApiMethod = function (path) {
    return path === 'step_result' || path === 'initialization_context' ? 'GET' : 'POST';
};
export var getLinkApiUrl = function (path) {
    var basePath = "".concat(LINK_API_URL, "/v1/link/ui/").concat(path, "/");
    if (path === 'step_result')
        return "".concat(basePath, "?date=").concat(process.env.NODE_ENV === 'test' ? '' : Date.now());
    return basePath;
};
export var getLinkApiHeaders = function (opts) {
    var headers = {
        'Content-Type': 'application/json',
        'Pinwheel-Link-Token': opts.linkToken,
        modal_session_id: opts.modalSessionId,
        login_attempt_id: opts.loginAttemptId,
    };
    if (!opts.linkTokenPayload._uid)
        Object.assign(headers, { unique_user_id: opts.uniqueUserId });
    return headers;
};
export var getLinkApiRequest = function (opts, path, body) { return [
    getLinkApiUrl(path),
    {
        method: getLinkApiMethod(path),
        headers: getLinkApiHeaders(opts),
        body: body || undefined,
    },
]; };
export var getParamsInitLoginRequest = function (opts) {
    var _a, _b;
    var body = {
        job: 'login',
        platformId: (_a = opts.selectedPlatform) === null || _a === void 0 ? void 0 : _a.id,
        employerId: (_b = opts.selectedEmployer) === null || _b === void 0 ? void 0 : _b.id,
    };
    // TODO (Octavio): Check if this is correct as we expect
    return getLinkApiRequest(opts, 'initialize', body);
};
export var getParamsInitDDRequest = function (opts) {
    var body = __assign({ job: 'direct_deposit_switch' }, opts.amountSelection);
    return getLinkApiRequest(opts, 'initialize', body);
};
export var getParamsNextRequest = function (opts, payload) {
    return getLinkApiRequest(opts, 'next', { payload: payload });
};
export var getParamsStepRequest = function (opts) {
    return getLinkApiRequest(opts, 'step_result');
};
export var getParamsInitializationContext = function (opts) {
    var _a = getLinkApiRequest(opts, 'initialization_context'), url = _a[0], req = _a[1];
    var qp = getEmployerOrPlatformQueryParam(opts.selectedEmployer, opts.selectedPlatform, opts.linkTokenPayload);
    var _b = qp.split('='), k = _b[0], v = _b[1];
    return ["".concat(url, "?").concat(toSnakeCase(k), "=").concat(v), req];
};
